/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_ErrorInputs */

const en_home_error = /** @type {(inputs: Home_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We couldn't load apartments. Please try again.`)
};

/**
* | output |
* | --- |
* | "We couldn't load apartments. Please try again." |
*
* @param {Home_ErrorInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home_error = /** @type {((inputs?: Home_ErrorInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_ErrorInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_error(inputs)
});